import { documentApi, physicalLocationApi } from '@/entities/Document';
import { functionalActivityApi } from '@/entities/FunctionalActivity';
import { positionApi } from '@/entities/Position';

export interface RecordConfigOption {
  id: number;
  name: string;
}

export interface RecordConfigProcedureOption {
  documentRevisionId: number;
  code: string;
}

const OPTION_LIST_LIMIT = 1000;

export function listCurrentProcedures(): Promise<RecordConfigProcedureOption[]> {
  return documentApi.getDocumentRevisionCodes({ prefixCode: 'PR', status: 'CURRENT' });
}

export async function listPhysicalLocations(): Promise<RecordConfigOption[]> {
  const locations = await physicalLocationApi.getPhysicalLocations();

  return locations.map(({ id, name }) => ({ id, name }));
}

export async function listPositions(): Promise<RecordConfigOption[]> {
  const { data } = await positionApi.searchPositions({
    active: true,
    type: 'POSITION',
    sort: 'name',
    order: 'asc',
    page: 1,
    limit: OPTION_LIST_LIMIT,
  });

  return data.map(({ id, name }) => ({ id, name }));
}

export async function listFunctionalActivities(): Promise<RecordConfigOption[]> {
  const { data } = await functionalActivityApi.search({
    active: true,
    sort: 'name',
    order: 'asc',
    page: 1,
    limit: OPTION_LIST_LIMIT,
  });

  return data.map(({ id, name }) => ({ id, name }));
}
